import React from 'react';
import { useTranslation } from 'react-i18next';

const WhyChooseUs = () => {
  const { t } = useTranslation();

  const reasons = [
    {
      title: t('whyUs.reasons.craftsmen.title'),
      description: t('whyUs.reasons.craftsmen.description'),
      icon: '👷‍♂️'
    },
    {
      title: t('whyUs.reasons.materials.title'),
      description: t('whyUs.reasons.materials.description'),
      icon: '✨'
    },
    {
      title: t('whyUs.reasons.dustless.title'),
      description: t('whyUs.reasons.dustless.description'),
      icon: '🌟'
    },
    {
      title: t('whyUs.reasons.satisfaction.title'),
      description: t('whyUs.reasons.satisfaction.description'),
      icon: '✅'
    },
    {
      title: t('whyUs.reasons.pricing.title'),
      description: t('whyUs.reasons.pricing.description'),
      icon: '💎'
    },
    {
      title: t('whyUs.reasons.timely.title'),
      description: t('whyUs.reasons.timely.description'),
      icon: '⏰'
    }
  ];

  return (
    <section id="why-us" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-wood-dark mb-4">
            {t('whyUs.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('whyUs.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="text-4xl mb-4">{reason.icon}</div>
              <h3 className="text-xl font-bold text-wood-dark mb-3">{reason.title}</h3>
              <p className="text-gray-600">{reason.description}</p>
            </div>
          ))}
        </div>

        {/* Testimonial Section */}
        <div className="bg-wood-brown rounded-xl p-8 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold mb-6">{t('whyUs.testimonials.title')}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white/10 rounded-lg p-6">
                <p className="italic mb-4">
                  {t('whyUs.testimonials.client1.text')}
                </p>
                <p className="font-semibold">{t('whyUs.testimonials.client1.name')}</p>
              </div>
              <div className="bg-white/10 rounded-lg p-6">
                <p className="italic mb-4">
                  {t('whyUs.testimonials.client2.text')}
                </p>
                <p className="font-semibold">{t('whyUs.testimonials.client2.name')}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl font-bold text-wood-dark mb-8">{t('whyUs.certifications.title')}</h3>
          <div className="flex flex-wrap justify-center gap-8">
            <div className="bg-white rounded-lg shadow-md p-6">
              <p className="font-semibold text-wood-brown">{t('whyUs.certifications.bbb.title')}</p>
              <p className="text-gray-600">{t('whyUs.certifications.bbb.subtitle')}</p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6">
              <p className="font-semibold text-wood-brown">{t('whyUs.certifications.licensed.title')}</p>
              <p className="text-gray-600">{t('whyUs.certifications.licensed.subtitle')}</p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6">
              <p className="font-semibold text-wood-brown">{t('whyUs.certifications.nwfa.title')}</p>
              <p className="text-gray-600">{t('whyUs.certifications.nwfa.subtitle')}</p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6">
              <p className="font-semibold text-wood-brown">{t('whyUs.certifications.bona.title')}</p>
              <p className="text-gray-600">{t('whyUs.certifications.bona.subtitle')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs; 